export function getClientAttributes() {
  const attributes: Record<string, string | number | boolean> = {}

  // Color scheme preference
  try {
    if (window.matchMedia) {
      attributes['color-scheme'] = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
    }
  } catch (e) {
    // Fallback for SSR
  }

  // Page visibility state
  try {
    if (document.visibilityState) {
      attributes['page-visibility-state'] = document.visibilityState
    }
  } catch (e) {
    // Fallback for SSR
  }

  // Navigation type
  try {
    if (window.performance && window.performance.navigation) {
      const navType = window.performance.navigation.type
      const typeMap: Record<number, string> = {
        0: 'navigate',
        1: 'reload',
        2: 'back_forward',
        255: 'other',
      }
      attributes['navigation-type'] = typeMap[navType] || 'unknown'
    }
  } catch (e) {
    // Fallback for SSR
  }

  return attributes
}
